// extracted by mini-css-extract-plugin
export default {"section":"details-section_section__U3PRD","section--read-only":"details-section_section--read-only__84OXE"};